<template>
  <div class="account">
    <div class="table">
      <span class="navigation">
        <span class="navContent">
          <b-icon
            id="previousMonth"
            v-on:click="previousMonth"
            icon="triangle-fill"
            title="Mois précédent"
          />
          <span id="displayMonth">
            {{ months[curMonth - 1] }} {{ year }}
            <b-button id="statsBtn" v-on:click="toggleStatsOverlay">
              <img
                class="navLogo"
                alt="Synthèse"
                src="../../assets/stats.png"
                title="Synthèse. Raccourcis : 'm','s'"
              />
            </b-button>
          </span>
          <b-icon
            id="nextMonth"
            v-on:click="nextMonth"
            icon="triangle-fill"
            title="Mois suivant"
          />
        </span>

        <span v-show="$store.getters.isManager">
          <select
            id="loginSelect"
            v-model="userId"
            title="Saisies pour l'utilisateur"
          >
            <option
              v-for="user in allUsers"
              v-bind:key="user.id"
              v-bind:value="user.id"
            >
              {{ user.login }}
            </option>
          </select>

          <b-button
            id="lockBtn"
            v-on:click="lock"
            title="Bouton de verrouillage et déverrouillage"
            style="display:none"
          >
            <img
              v-show="$store.state.isLock"
              class="navLogo"
              alt="Verrouiller"
              src="../../assets/lock_close.png"
            />
            <img
              v-show="!$store.isLock"
              class="navLogo"
              alt="Déverrouiller"
              src="../../assets/lock_open.png"
            />
          </b-button>
        </span>
      </span>

      <table class="table table-sm mx-auto col-sm-12">
        <thead>
          <th scope="col" class="today"></th>
          <th scope="col" class="week" colspan="3"></th>
          <th scope="col" class="add"></th>
          <th scope="col"></th>
          <th scope="col" class="total"></th>
          <th scope="col" class="details"></th>
          <th scope="col" class="copy"></th>
        </thead>
        <tbody>
          <tr
            v-for="day in nbDays"
            :key="day"
            :id="day"
            v-bind:style="{
              background: holidays[day] ? allColors.HOLIDAYS : allColors.NONE
            }"
          >
            <th class="row today">
              <span
                id="rightDay"
                v-if="
                  day === today &&
                    curMonth === todaysMonth &&
                    year === todaysYear
                "
              ></span>
            </th>
            <td
              class="week"
              v-bind:style="{
                background:
                  (day + shiftDay) % 7 == 6
                    ? allColors.TIME_SATURDAY
                    : (day + shiftDay) % 7 == 0
                    ? allColors.TIME_SUNDAY
                    : allColors.NONE
              }"
            >
              <span v-if="(day + shiftDay) % 7 == 1">
                {{ getWeek(day) }}
              </span>
            </td>
            <td
              class="date"
              v-bind:style="{
                background:
                  (day + shiftDay) % 7 == 6
                    ? allColors.TIME_SATURDAY
                    : (day + shiftDay) % 7 == 0
                    ? allColors.TIME_SUNDAY
                    : allColors.NONE
              }"
            >
              {{ days[(day + shiftDay) % 7] }}
            </td>
            <td
              class="number"
              v-bind:style="{
                background:
                  (day + shiftDay) % 7 == 6
                    ? allColors.TIME_SATURDAY
                    : (day + shiftDay) % 7 == 0
                    ? allColors.TIME_SUNDAY
                    : allColors.NONE
              }"
            >
              {{ day }}
            </td>
            <td
              class="add"
              v-on:click="toggleOverlay(day)"
              title="Ajouter une saisie"
            >
              <b-icon icon="plus" />
            </td>
            <td v-if="holidays[day] && (!events[day] || events[day].length == 0)"
              class="events quickAdd"
              v-on:click="toggleOverlay(day)"
              :style="{
                background: holidays[day] ? allColors.HOLIDAYS : allColors.NONE
              }"
            ></td>
            <td v-else-if="holidays[day]"
              class="events" :style="{
                background: allColors.TIME_WRONG
              }">
                <span v-for="ev in events[day]" :key="ev.id">
                <Event
                  :event="ev"
                  :nbEvent="events[day].length"
                  :idToColor="projectIdToColor"
                  :maxDuration="maxDuration"
                  v-on:toggleEdit="toggleEdit"
                />
              </span>
            </td>
            <td
              v-else-if="!events[day] || events[day].length == 0"
              class="events quickAdd"
              v-on:click="toggleOverlay(day)"
              :style="() => dynamicStyleTd(event[day])"
            ></td>
            <td v-else class="events" :style="() => dynamicStyleTd(event[day])">
              <span v-for="ev in events[day]" :key="ev.id">
                <Event
                  :event="ev"
                  :nbEvent="events[day].length"
                  :idToColor="projectIdToColor"
                  :maxDuration="maxDuration"
                  v-on:toggleEdit="toggleEdit"
                />
              </span>
            </td>
            <td
              class="total"
              v-bind:style="{
                background:
                  (day + shiftDay) % 7 == 6
                    ? allColors.TIME_SATURDAY
                    : (day + shiftDay) % 7 == 0
                    ? allColors.TIME_SUNDAY
                    : allColors.TIME_EMPTY
              }"
            >
              <Time
                :events="events"
                :day="day"
                :currentDay="today"
                :numDay="(day + shiftDay) % 7"
                :holidays="holidays"
                :selectedMonth="curMonth"
                :todaysMonth="todaysMonth"
                :selectedYear="year"
                :todaysYear="todaysYear"
              />
            </td>
            <td
              class="details smallFont"
              v-on:click="toggleDetailsOverlay(day)"
              title="Détails"
            >
              <b-icon icon="eye" />
            </td>
            <td
              class="copy smallFont"
              v-on:click="toggleCopyOverlay(day)"
              title="Copier"
            >
              <b-icon icon="files" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <EventOverlay
      v-show="overlay"
      :overlay="overlay"
      v-on:cancel="toggleOverlay"
      v-on:addLog="addEvent"
      v-on:editLog="editLog"
      :events="events"
      :day="daySelected"
      :event="eventSelected"
      :isEdit="editing"
      v-on:deleteLog="deleteEvent"
      :year="year"
      :month="curMonth"
      :userId="userId"
    />
    <EventDetailsOverlay
      v-on:close="toggleDetailsOverlay"
      v-show="detailsOverlay"
      :events="events[daySelected]"
    />
    <EventCopyOverlay
      v-if="copyOverlay"
      :overlay="copyOverlay"
      v-on:cancel="toggleCopyOverlay"
      v-on:confirm="copyEvent"
      :maxDay="nbDays"
      :copyFrom="daySelected"
      :shift="shiftDay"
      :year="year"
      :month="curMonth"
      :holidays="holidays"
    />
    <StatsOverlay
      v-show="statsOverlay"
      :overlay="statsOverlay"
      v-on:close="toggleStatsOverlay"
      :events="events"
    />
  </div>
</template>

<script>
const axios = require("axios");

import { colors } from "../../settings.js";
import moment from 'moment'

import Event from "./Event.vue";
import EventOverlay from "./EventOverlay.vue";
import EventDetailsOverlay from "./EventDetailsOverlay.vue";
import EventCopyOverlay from "./EventCopyOverlay.vue";
import StatsOverlay from "./StatsOverlay.vue";
import Time from "./Time.vue";

export default {
  name: "Dashboard",
  components: {
    EventOverlay,
    Event,
    EventDetailsOverlay,
    EventCopyOverlay,
    StatsOverlay,
    Time
  },
  data() {
    return {
      nbDays: 0,
      events: [],
      totalDurationEvents: [],
      maxDuration: 420,
      daySelected: 0,
      overlay: false,
      detailsOverlay: false,
      copyOverlay: false,
      statsOverlay: false,
      today: "",
      days: ["D", "L", "M", "M", "J", "V", "S"],
      shiftDay: 0, //calcul the first day of the month
      months: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre"
      ],
      curMonth: 0, // January is  1
      todaysMonth: 0,
      year: 0,
      todaysYear: 0,
      holidays: [],
      eventSelected: null,
      editing: false,
      allColors: colors,
      projectIdToColor: [], // try to use a unique color using project id
      shortcutAdd: false,
      shortcutEscp: false,
      shortcutStats: false,
      lockDate: "",
      role: "",
      login: "",
      allUsers: [],
      userId: 0
    };
  },
  created: function() {
    window.addEventListener("keyup", this.processKey);
    window.addEventListener("keydown", this.stateKey);
    axios
      .get(this.$store.state.apiUrl + "config/getLock", {
        params: {
          login: localStorage.login,
          password: localStorage.pass
        }
      })
      .then(response => (this.lockDate = response.data.paramValue))
      .catch(e => {
        this.printError(e);
      });
  },
  destroyed() {
    window.removeEventListener("keyup", this.processKey);
    window.removeEventListener("keydown", this.stateKey);
  },
  mounted: function() {
    var tmpDate = new Date();
    this.year = tmpDate.getFullYear();
    this.todaysYear = this.year;
    this.curMonth = tmpDate.getMonth() + 1;
    this.today = tmpDate.getDate();
    this.todaysMonth = this.curMonth;
    this.login = localStorage.login;
    this.role = localStorage.role;
    this.userId = Number(localStorage.id);
  },
  watch: {
    lockDate: function() {
      this.setLock();
    },
    curMonth: function() {
      this.setLock();
      this.setDaysInMonth(this.year, this.curMonth - 1); // Get the number of day in this month
      this.calculShift(this.year, this.curMonth);

      axios
        .get(
          this.$store.state.apiUrl +
            "holidays/monthly/" +
            this.curMonth +
            "/" +
            this.year,
          {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          }
        )
        .then(
          response => (this.resetHolidays(), this.setHolidays(response.data))
        )
        .catch(e => {
          this.printError(e);
        });
      // Réservé aux rôles privilégiés (même condition que le v-show de allUsers) :
      // l'endpoint user/users est ROLE_ADMIN côté serveur, l'appeler en tant
      // que simple utilisateur renvoie un 403 (toast inutile).
      if (this.$store.getters.isManager) {
        axios
          .get(this.$store.state.apiUrl + "user/users", {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          })
          .then(response => (this.allUsers = response.data))
          .catch(e => {
            this.printError(e);
          });
      }
      this.getLogs();
    },
    userId: function() {
      this.getLogs();
    }
  },
  computed: {
    dynamicStyleTd: function() {
      if(this.maxDuration > 420){
        var percent = (420*100)/this.maxDuration-0.3;
        return {
          backgroundImage: 'linear-gradient(to right, white '+percent+'%, #ffa6a6 '+percent+'%, #ffa6a6 99.5%, white 99.5%)'
        }
      }
      return '';
    }
  },
  methods: {
    stateKey: function(e) {
      // 27 => 'esc'
      if (e.keyCode == 27) {
        this.shortcutEsc = true;
      }
      // 65 => 'a'
      // 107 => '+'
      // 13 => 'enter'
      if (e.keyCode == 65 || e.keyCode == 107 || e.keyCode == 13) {
        if (
          !this.copyOverlay &&
          !this.detailsOverlay &&
          !this.overlay &&
          !this.statsOverlay
        ) {
          this.shortcutAdd = true;
        }
      }

      // 77 => 'm'
      // 83 => 's'
      if (e.keyCode == 77 || e.keyCode == 83) {
        if (
          !this.copyOverlay &&
          !this.detailsOverlay &&
          !this.overlay &&
          !this.statsOverlay
        ) {
          this.shortcutStats = true;
        }
      }
    },
    processKey: function() {
      if (this.shortcutEsc) {
        if (this.detailsOverlay) {
          this.detailsOverlay = false;
        }
        if (this.copyOverlay) {
          this.copyOverlay = false;
        }
        if (this.overlay) {
          this.overlay = false;
        }
        if (this.statsOverlay) {
          this.statsOverlay = false;
        }
        this.shortcutEsc = false;
      }
      if (this.shortcutAdd) {
        this.toggleOverlay(this.today);
        this.shortcutAdd = false;
      }
      if (this.shortcutStats) {
        this.statsOverlay = true;
        this.shortcutStats = false;
      }
    },
    resetData: function() {
      this.nbDays = 0;
      this.daySelected = 0;
      this.shiftDay = 0;
      this.eventSelected = null;
      this.events = [];
      this.holidays = [];
      this.totalDurationEvents = [];
      this.maxDuration = 420;
    },
    resetEvents: function() {
      this.events = [];
      this.totalDurationEvents = [];
      this.maxDuration = 420;
    },
    resetHolidays: function() {
      this.holidays = [];
    },
    getLogs: function() {
      /* Defined the start of the month and start of the next one */
      var startDate = this.year + "-" + this.curMonth + "-01";
      var nextMonth = this.curMonth + 1; // next month is +1, Date is January based 1 => +1
      var yearNextMonth = this.year;

      if (nextMonth > 12) {
        // handle december
        nextMonth = 1;
        yearNextMonth++;
      }

      // CROSS COMPATIBILITY -> FIREFOX NEED 0 IF MONTH < 10
      var tmpEndDate = new Date(`${yearNextMonth}-${nextMonth >= 10 ? nextMonth : `0${nextMonth}`}`);
      var endDate =
        tmpEndDate.getFullYear() + "-" + ((tmpEndDate.getMonth() + 1) > 10 ? (tmpEndDate.getMonth() + 1) : "0"+ (tmpEndDate.getMonth() + 1)) + "-00"; // getMonth is january 0 based

      axios
        .get(
          this.$store.state.apiUrl +
            "time/" +
            this.userId +
            "/" +
            startDate +
            "/" +
            endDate,
          {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          }
        )
        .then(response => (this.resetEvents(), this.setEvents(response.data), this.setTotalDurationEvents(response.data)))
        .catch(e => {
          this.printError(e);
        });
    },
    previousMonth: function() {
      this.resetData();
      if (this.curMonth <= 1) {
        this.curMonth = 12;
        this.year--;
      } else {
        this.curMonth--;
      }
    },
    nextMonth: function() {
      this.resetData();
      if (this.curMonth >= 12) {
        this.curMonth = 1;
        this.year++;
      } else {
        this.curMonth++;
      }
    },
    lock: function() {
      var lockDate = this.year + "-" + this.curMonth;

      if (this.$store.state.isLock) {
        lockDate = this.year + "-" + (this.curMonth - 1);
      }

      axios
        .put(
          this.$store.state.apiUrl + "config/updateLock",
          {
            lockedDate: lockDate
          },
          {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          }
        )
        .then(response => (this.lockDate = response.data.paramValue))
        .catch(e => {
          this.printError(e);
        });
    },
    setLock: function() {
      this.$store.commit('setIsLock', false);
    },

    isLock: function(SelectedDate) {
      if (SelectedDate) {
        var SDate = new Date(SelectedDate);
        SDate.setHours(0, 0, 0, 0);

        var Now = new Date();
        Now.setHours(0, 0, 0, 0);

        var DebutMois = new Date();
        DebutMois.setHours(0, 0, 0, 0);
        DebutMois.setDate(1);

        var DebutMoisDernier = new Date();
        DebutMoisDernier.setHours(0, 0, 0, 0);
        DebutMoisDernier.setDate(1);
        DebutMoisDernier.setMonth(Now.getMonth() - 1);

        var DebutMois5 = new Date();
        DebutMois5.setHours(0, 0, 0, 0);
        DebutMois5.setDate(5);

        if (this.$store.getters.isManager) {
          return false;
        }

        if (SDate >= DebutMois) {
          return false;
        } else if (
          Now >= DebutMois &&
          Now <= DebutMois5 &&
          SDate >= DebutMoisDernier
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    setDaysInMonth: function(year, month) {
      // January is 0
      this.nbDays = new Date(year, month + 1, 0).getDate();
    },
    calculShift: function(year, month) {
      this.shiftDay = new Date(year + "-" + month + "-01").getDay() - 1; // minus 1 because Dimanche is 0
    },
    getWeek: function(day) {
      var date = new Date(this.year + "-" + this.curMonth + "-" + day);
      return moment(date).isoWeek(); // Return week number
    },
    setEvents: function(data) {
      if (data) {
        data.forEach(value => {
          var tmpDate = value.date.split("-");
          var dateYear = Number(tmpDate[0]);
          var dateMonth = Number(tmpDate[1]);
          var dateDay = Number(tmpDate[2]); // date's format is Y-M-D
          if (this.year == dateYear && this.curMonth == dateMonth) {
            var tmp;

            if (this.projectIdToColor.indexOf(value.project_id) < 0) {
              this.projectIdToColor.push(value.project_id);
            }

            if (this.events[dateDay] && this.events[dateDay].length > 0) {
              // handle multiple events in a day
              tmp = this.events[dateDay];
              tmp.push(value);
            } else {
              tmp = [value];
            }

            this.$set(this.events, dateDay, tmp);
          }
        });
      }
    },
    setTotalDurationEvents: function(data) {
      if (data) {
        data.forEach(value => {
          var tmpDate = value.date.split("-");
          var dateYear = Number(tmpDate[0]);
          var dateMonth = Number(tmpDate[1]);
          var dateDay = Number(tmpDate[2]); // date's format is Y-M-D
          if (this.year == dateYear && this.curMonth == dateMonth) {            
            var splitTime = value.duration.split(":");
            var minutes = Number(splitTime[1]) + (Number(splitTime[0])*60);
            var tmp;
            if (this.totalDurationEvents[dateDay] && this.totalDurationEvents[dateDay] > 0 && this.totalDurationEvents[dateDay] !== 420) {
              // handle multiple events in a day
              tmp = this.totalDurationEvents[dateDay] + minutes;
            } else {
              tmp = minutes;
            }
          }
          this.$set(this.totalDurationEvents, dateDay, tmp);
        });

        this.totalDurationEvents.forEach((time) => {
          this.maxDuration = (this.maxDuration < time) ? time : this.maxDuration;
        });
      }
    },
    setHolidays: function(data) {
      if (data) {
        data.forEach(value => {
          var day = value.date.split("/")[0];
          this.holidays[Number(day)] = true;
        });
      }
    },
    toggleOverlay: function(day) {
      var TheDate = new Date(this.year + "-" + this.curMonth + "-" + day);
      if (!isNaN(TheDate) && this.isLock(TheDate)) {
        console.log("toggleOverlay");
        this.printLockMessage();
      } else {
        this.daySelected = day;
        this.editing = false;
        this.overlay = !this.overlay;
      }
    },
    toggleDetailsOverlay: function(day) {
      this.daySelected = day;
      this.detailsOverlay = !this.detailsOverlay;
    },
    toggleStatsOverlay: function() {
      this.statsOverlay = !this.statsOverlay;
    },
    addEvent: function(data) {
      var tmpData = new FormData();
      for (var field in data) {
        tmpData.append(field, data[field]);
      }

      console.log("try to add copies");
      console.log(data);
      console.log(tmpData);

      if (data) {
        if (this.isLock(data.date)) {
          console.log("Locked day !");
          this.printLockMessage();
        } else {
          console.log("Adding log");
          axios
            .post(this.$store.state.apiUrl + "time/newTime", tmpData, {
              params: {
                login: localStorage.login,
                password: localStorage.pass
              }
            })
            .then(response => { 
              console.log("Adding OK");
              console.log(response.data);
              this.setEvents(response.data); 
              this.setTotalDurationEvents(response.data); 
              })
            .catch(e => {
              console.log("Adding ERROR");
              console.log(e);
              this.printError(e);
            });
        }
        this.overlay = false;
      }
    },
    editLog: function(data) {
      if (data) {
        if (this.isLock(data.date)) {
          this.printLockMessage();
        } else {
          axios
            .put(this.$store.state.apiUrl + "time/update/" + data.id, data, {
              params: {
                login: localStorage.login,
                password: localStorage.pass
              }
            })
            .then(response => this.editInEvents(response.data[0]))
            .catch(e => {
              this.printError(e);
            });
        }
        this.overlay = false;
      }
    },
    toggleEdit: function(event) {
      this.eventSelected = event;
      if (this.isLock(this.eventSelected.date)) {
        this.printLockMessage();
      } else {
        this.daySelected = Number(this.eventSelected.date.split("-")[2]);
        this.editing = true;
        this.overlay = !this.overlay;
      }
    },
    deleteEvent: function(id) {
      this.events.forEach((element, index) => {
        if(element[0]?.id === id || element[0] === undefined){
          this.totalDurationEvents[index] = undefined;
        } 
      });
      if (this.$store.state.isLock) {
        this.printLockMessage();
      } else {
        axios
          .delete(this.$store.state.apiUrl + "time/delete/" + id, {
            params: {
              login: localStorage.login,
              password: localStorage.pass
            }
          })
          .then(response => {
            this.checkDelete(response, id)
            let duration = 400;
            this.events.forEach((value, index) => {
              value.forEach((event, innerIndex) => {
                if(event.id === id) return;
                let currentDuration = (Number(event.duration.split(':')[0]) * 60) + Number(event.duration.split(':')[1]);
                if(currentDuration > duration){
                  duration = currentDuration;
                }
                if (event.id == id) {
                  this.events[index].splice(innerIndex, 1); // splice trigger the render
                }
              });
              this.maxDuration = duration;
            });
          })
          .catch(e => {
            this.printError(e);
          });
      }
      this.overlay = false;
    },
    checkDelete: function(response, id) {
      if (response.status == 200) {
        // this.events is a two dimensional array
        this.events.forEach((value, index) => {
          value.forEach((event, innerIndex) => {
            if (event.id == id) {
              this.events[index].splice(innerIndex, 1); // splice trigger the render
            }
          });
        });
      }
    },
    editInEvents: function(newEvent) {
      var id = newEvent.id;
      this.events.forEach((value, index) => {
        value.forEach((event, innerIndex) => {
          if (event.id == id) {
            this.events[index].splice(innerIndex, 1, newEvent);
          }
        });
      });
    },
    toggleCopyOverlay: function(fromDay) {
      var TheDate = new Date(this.year + "-" + this.curMonth + "-" + fromDay);
      if (!isNaN(TheDate) && this.isLock(TheDate)) {
        this.printLockMessage();
      } else {
        this.daySelected = fromDay;
        this.copyOverlay = !this.copyOverlay;
      }
    },
    copyEvent: function(toDays) {
      toDays.forEach(date => {
        if (this.events[this.daySelected] && ! this.holidays[date]) {
          axios.get(this.$store.state.apiUrl + "time/getOnDate/" + date + "/" + this.userId, {
              params: {
              login: localStorage.login,
              password: localStorage.pass
              }
          })
          .then(response => {
            if(response.data == 0){
              this.events[this.daySelected].forEach(value => {
                var tmp = {
                  billable: value.billable,
                  userId: value.user_id,
                  duration: value.duration,
                  projectId: value.project_id,
                  reference: value.reference ? value.reference : "",
                  comment: value.comment ? value.comment : "",
                  date: date,
                  copy: true
                };
                this.addEvent(tmp);
              });
            }
          });
        }
      });
      this.copyOverlay = false;
    },
    printLockMessage: function() {
      this.$toasted
        .show("Modification impossible, le mois est déjà bloqué", {
          position: "bottom-center",
          theme: "outline"
        })
        .goAway(2000);
    },
    printError: function(e) {
      console.log(e);
      this.$toasted
        .show("Erreur de connexion, veuillez essayer ultérieurement", {
          position: "bottom-center",
          theme: "outline"
        })
        .goAway(2000);
    }
  }
};
</script>

<style scoped>
.events {
  text-align: left;
}

th {
  border-top: 0px;
}

td {
  vertical-align: middle;
}

.smallFont {
  font-size: 12px;
}

.table-sm td {
  padding-top: 0;
  padding-bottom: 0;
}

.details,
.copy {
  width: 1em;
}

.week,
.date,
.number {
  width: 0.5em;
  border-top: 0px;
}

.add,
.total {
  width: 1em;
}

.total {
  padding: 0px;
}

td.add:hover,
td.details:hover,
td.copy:hover {
  background-color: #e5e5e5;
  cursor: pointer;
}

.table thead th {
  padding: 0;
}

.today {
  border-top: 0px;
  border-bottom: 0px;
  font-weight: normal;
  font-size: 11px;
  width: 2.5em;
  margin: 0;
}

#rightDay {
  background-color: #fff2c6;
  margin-top: 3px;
}

#rightDay:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 11px solid transparent;
  margin: -6px 0 0 0;
  border-left: 20px solid #fec053;
}

tr:first-child {
  background-color: transparent;
}

table {
  font-size: 0.91em;
}

tr:hover {
  background-color: #fce5dc;
}

#nextMonth:hover,
#previousMonth:hover,
td.quickAdd:hover {
  cursor: pointer;
}

.navigation {
  position: absolute;
  top: 25px;
  left: 50%;
  font-size: 24px;
  font-weight: bold;
  width: 440px;
  margin-left: -140px;
  height: 30px;
  text-align: left;
}

#displayMonth {
  display: inline-block;
  width: 235px;
  height: 100%;
}

.navContent {
  width: 280px;
  text-align: center;
}

.navLogo {
  display: block;
  height: 100%;
}

#loginSelect {
  width: 120px;
  font-size: 16px;
  position: relative;
  background: none;
  overflow: hidden;
  border: 1px solid;
  border-radius: 0.3em;
}

#lockBtn {
  margin-left: 10px;
  padding: 0;
  height: 100%;
  background: none;
  border: none;
}

#previousMonth,
#nextMonth {
  font-size: 22px;
}

#previousMonth {
  transform: rotate(-90deg);
}

#nextMonth {
  transform: rotate(90deg);
}

#statsBtn {
  padding: 0;
  height: 100%;
  background: none;
  border: none;
}

@media screen and (max-width: 800px){
  .navigation {
    top: 50px;
    width: 100vw!important;
    max-width: 100vw!important;
    left: 62%;
    max-width: 300px;
    font-size: 17px;
  }
  #displayMonth{
    width: 135px;
  }
}

@media screen and (max-width: 729px){
  .navigation {
    top: 50px!important;
    left: 65%!important;
  }
}
@media screen and (max-width: 630px){
  .navigation {
    top: 120px!important;
    left: 65%!important;
  }
}

@media screen and (max-width: 360px){
  .navigation {
    top: 140px;
    left: 45%;
  }
}

</style>
